import { APP_MODES, APP_MODE } from "@/shared";

const w = (window as any) ?? {};

export function isMode(s: string, mode: APP_MODE): s is APP_MODE {
  return APP_MODES[mode] == s;
}

function fromString(s?: string): APP_MODE {
  if (!s) throw "App mode not set";
  const mode = Object.keys(APP_MODES).find((a) => isMode(s, a as APP_MODE));
  if (mode) return mode as APP_MODE;
  else throw "Unknown app mode" + s;
}

export function useEnv() {
  const protocol = (w.VITE_API_PROTOCOL ??
    import.meta.env.VITE_API_PROTOCOL ??
    "http") as string;
  const host = (w.VITE_API_HOST ??
    import.meta.env.VITE_API_HOST ??
    "localhost") as string;
  const port = (w.VITE_API_PORT ??
    import.meta.env.VITE_API_PORT ??
    "3000") as string;
  const path = (w.VITE_API_PATH ??
    import.meta.env.VITE_API_PATH ??
    "") as string;
  const environment = (w.VITE_ENVIRONMENT ??
    import.meta.env.VITE_ENVIRONMENT ??
    process.env.VITE_ENVIRONMENT ??
    "production") as string;
  const mode =
    (w.VITE_APP_MODE as APP_MODE) ??
    (fromString(process.env.VITE_APP_MODE) as APP_MODE);
  const sentryDSN =
    w.VITE_SENTRY_DSN ??
    process.env.VITE_SENTRY_DSN ??
    import.meta.env.VITE_SENTRY_DSN;
  const getAuthPrefix = () => APP_MODES[mode];
  function withPrefix(s: string): string {
    return "/" + getAuthPrefix() + s;
  }

  return {
    protocol,
    host,
    port,
    path,
    environment,
    mode,
    sentryDSN,
    withPrefix,
  };
}
